import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import './Exclusivebundles.css'

import Wwe from '../images/icons/10.png'
import MLB from '../images/icons/2.png'
import Ufc from '../images/icons/6.png'
import Img1 from '../images/buddles/1.png'
import Img2 from '../images/buddles/2.png'
import Img3 from '../images/buddles/3.png'

gsap.registerPlugin(ScrollTrigger)

const bundles = [
  {
    id: 'wwe',
    image: Img1,
    icon: Wwe,
    name: 'WWE Bundle',
    text: 'Step into the ring with a powerhouse collection featuring championship legends, rare parallels, autograph cards, rookie appearances, and premium WWE inserts.',
    features: ['25 Premium Cards', '6 Rare Inserts', '3 Autograph Cards', 'Limited Bundle Drop'],
    price: 799,
  },
  {
    id: 'mlb',
    image: Img2,
    icon: MLB,
    name: 'Diamond Dynasty Bundle',
    text: 'A premium baseball collection loaded with iconic MLB stars, rookie sensations, graded collectibles, and legendary franchise moments.',
    features: ['30 Collector Cards', '8 Rookie Cards', '5 Rare Parallels', 'Limited Weekly Drop'],
    price: 999,
  },
  {
    id: 'ufc',
    image: Img3,
    icon: Ufc,
    name: 'Octagon Elite Bundle',
    text: 'Built for fight fans and collectors chasing greatness. This UFC bundle delivers championship-level cards, rookie contenders, and rare numbered editions from the biggest names in combat sports.',
    features: ['18 Premium Cards', '4 Numbered Variants', '2 Signed Cards', 'Collector Exclusive'],
    price: 999,
  },
]

function BundleCard({ bundle, onViewBundle, onSecureCollection }) {
  return (
    <article className="eb-card">
      <div className="eb-card__media">
        <img src={bundle.image} alt={bundle.name} className="eb-card__image" />
      </div>

      <div className="eb-card__icon">
        <img src={bundle.icon} alt="" />
      </div>

      <h3 className="eb-card__name">{bundle.name}</h3>
      <p className="eb-card__text">{bundle.text}</p>

      <div className="eb-card__features">
        {bundle.features.map((feature) => (
          <span key={feature} className="eb-pill">
            {feature}
          </span>
        ))}
      </div>

      <div className="eb-card__price">${bundle.price}</div>

      <div className="eb-card__actions">
        <button type="button" className="eb-btn eb-btn--primary" onClick={() => onViewBundle(bundle)}>
          View Bundle
        </button>
        <button
          type="button"
          className="eb-btn eb-btn--secondary"
          onClick={() => onSecureCollection(bundle)}
        >
          Secure Collection
        </button>
      </div>
    </article>
  )
}

function Exclusivebundles({ onViewBundle = () => {}, onSecureCollection = () => {} }) {
  const sectionRef = useRef(null)
  const headerRef = useRef(null)
  const gridRef = useRef(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: 'top 78%',
          once: true,
        },
        defaults: { ease: 'power3.out' },
      })

      tl.from(headerRef.current.children, {
        opacity: 0,
        y: 22,
        duration: 0.6,
        stagger: 0.08,
      }).from(
        gridRef.current.children,
        {
          opacity: 0,
          y: 34,
          scale: 0.98,
          duration: 0.7,
          stagger: 0.12,
        },
        '-=0.2'
      )
    }, sectionRef)

    return () => ctx.revert()
  }, [])

  return (
    <section className="eb-section" ref={sectionRef}>
      <div className="eb-container">
        <div className="eb-header" ref={headerRef}>
          <span className="eb-eyebrow">Exclusive Bundles</span>

          <h2 className="eb-title">
            Build Your
            <br />
            Collection Faster,
            <br />
            Bigger, Better
          </h2>

          <p className="eb-subtitle">
            Skip the hunt and secure complete themed collections in one move. OBC Bundle Drops are
            designed for collectors who want instant value, stronger collections, and high-energy
            exclusives across WWE, UFC, MLB, Football, Pok&eacute;mon, and more.
          </p>
        </div>

        <div className="eb-grid" ref={gridRef}>
          {bundles.map((bundle) => (
            <BundleCard
              key={bundle.id}
              bundle={bundle}
              onViewBundle={onViewBundle}
              onSecureCollection={onSecureCollection}
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default Exclusivebundles
